export default function BrandIntro() {
  return (
    <section>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg">
          <i className="ri-building-4-line text-xl"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
          品牌介绍
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
        <div>
          <p className="text-foreground-600 leading-relaxed text-sm mb-4">
            <strong className="text-foreground-900">黑料入口</strong>成立于2024年，是中文互联网领先的娱乐资讯聚合平台。
            我们专注于为用户提供最新、最全面的网红塌房、明星翻车、行业内幕等热门吃瓜内容，
            致力于打造一个集资讯浏览、热点追踪、深度分析于一体的综合性内容平台。
          </p>
          <p className="text-foreground-600 leading-relaxed text-sm mb-4">
            我们的团队由资深媒体人、专业调查记者和技术开发人员组成，
            24小时关注各大平台的动态热点，确保用户能够第一时间获取最新最热的黑料资讯。
            从明星私生活到行业潜规则，从网红翻车现场到综艺幕后真相，黑料入口始终坚持
            <strong className="text-foreground-900">真实、客观、深度</strong>的内容理念。
          </p>
          <p className="text-foreground-600 leading-relaxed text-sm">
            自上线以来，黑料入口已累计服务超过5000万用户，
            每日更新超过50篇原创及精选内容，成为众多吃瓜用户的首选平台。
            我们的slogan是：<strong className="text-primary-600">吃瓜，就上黑料入口。</strong>
          </p>
        </div>
        <div className="rounded-lg overflow-hidden h-64 lg:h-auto">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20with%20warm%20ambient%20lighting%2C%20clean%20minimal%20workspace%2C%20professional%20creative%20atmosphere%2C%20dark%20wood%20desk%20with%20laptop%2C%20soft%20golden%20accents%2C%20elegant%20interior%20design%2C%20high%20detail%2C%20calm%20and%20focused%20mood%2C%20warm%20neutral%20color%20palette&width=800&height=500&seq=about-brand-2026&orientation=landscape"
            alt="黑料入口 - 品牌介绍，专业编辑团队"
            title="黑料入口 - 品牌编辑团队"
            className="w-full h-full object-cover object-top rounded-lg"
          />
        </div>
      </div>
    </section>
  );
}